export const JS_JOIN_HOOK = 'js-open-popup-join';
